module.exports = __webpack_public_path__ + "static/img/new2.34120f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new2.jpg
// module id = y/0U
// module chunks = 1